import React from 'react';
import Link from 'next/link';
import UserAvatar from ':src/components/UserAvatar';
import { Solution } from ':src/types';

type SolutionsListProps = {
  className?: string;
  solutions: Solution[];
  emptyStateText: string;
  label?: string;
  emptyStateClassName?: string;
};

export default function SolutionsList({
  className,
  solutions,
  label,
  emptyStateText,
  emptyStateClassName,
}: SolutionsListProps) {
  return (
    <div className={className}>
      {label && <h2 className="text-2xl mb-6">{label}</h2>}

      {solutions.map(({ id, title, description, user }) => (
        <Link key={id} href={`/solutions/${id}`}>
          <a className="py-2 shadow hover:shadow-lg transition-shadow rounded block">
            <div className="px-4 py-2 border-b">
              <h3 className="mb-2 text-lg">{title}</h3>
              <p className="text-gray-500">{description}</p>
            </div>
            <div className="p-4">
              <div className="flex items-center">
                <UserAvatar imageSrc={user.profilePicUrl} />
                <div className="ml-4 space-y-1">
                  <div className="font-bold">{user.name}</div>
                  <div className="text-gray-500">{user.username}</div>
                </div>
              </div>
            </div>
          </a>
        </Link>
      ))}
      {!solutions.length && (
        <div className={emptyStateClassName}>{emptyStateText}</div>
      )}
    </div>
  );
}
